import React, { useEffect, useState } from "react";
import "./SenderCookieBanner.css";
import { apiJsonRequest } from "../../utils/apiRequest";
import { ACCEPT_ALL, ESSENTIAL_ONLY, getSenderChoice, isSenderContext, setSenderChoice } from "../../utils/cookieConsentUtils";
import { PRIVACY_PAGE_PATH } from "../../utils/privacyPage";
import CookiePreferencesButton from "./CookiePreferencesButton";

const getSenderIconPosition = () => (window?.kzSenderConsent?.iconPosition === "left" ? "left" : "right");

const saveIconPosition = (position) => {
  window.kzSenderConsent.iconPosition = position;
  apiJsonRequest("/sender_cookie_consent/icon_position.json", "PATCH", { position }).catch((error) => console.error(error));
};

const SenderCookieBanner = () => {
  const [open, setOpen] = useState(() => isSenderContext() && !getSenderChoice());

  useEffect(() => {
    if (!isSenderContext()) return undefined;
    const reopen = () => setOpen(true);
    window.addEventListener("openCookieConsentModal", reopen);
    return () => window.removeEventListener("openCookieConsentModal", reopen);
  }, []);

  if (!isSenderContext()) return null;
  if (!open) {
    return <CookiePreferencesButton position={getSenderIconPosition()} onPositionChange={saveIconPosition} />;
  }

  const choose = (status) => {
    setSenderChoice(status);
    setOpen(false);
    apiJsonRequest("/sender_cookie_consent.json", "PATCH", { status }).catch((error) => console.error(error));
  };

  return (
    <div className="kz-sender-cookie-banner" role="region" aria-label="Cookie preferences">
      <p className="kz-sender-cookie-banner__text">
        Kinetizine uses essential cookies to keep you signed in. With your consent, we also load third-party content
        such as embedded videos, GIF search and profile pictures, which may set their own cookies. Until you accept,
        that content stays blocked. <a href={PRIVACY_PAGE_PATH} target="_blank" rel="noopener noreferrer">Privacy Notice</a>
      </p>
      <div className="kz-sender-cookie-banner__actions">
        <button type="button" className="kz-sender-cookie-banner__btn" onClick={() => choose(ESSENTIAL_ONLY)}>
          Essential only
        </button>
        <button type="button" className="kz-sender-cookie-banner__btn" onClick={() => choose(ACCEPT_ALL)}>
          Accept all
        </button>
      </div>
    </div>
  );
};

export default SenderCookieBanner;
